function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "messages-icon",
  transform: "translate(-316.047 -133.761)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_405",
  "data-name": "Ret\\xE2ngulo 405",
  width: 48,
  height: 48,
  rx: 9.047,
  transform: "translate(316.047 133.761)",
  fill: "#79ccb8"
}), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_286",
  "data-name": "Grupo 286"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_284",
  "data-name": "Grupo 284"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4443",
  "data-name": "Caminho 4443",
  d: "M340.172,140.044a17.6,17.6,0,0,0-3.963.465c5.435,1.8,9.49,8.776,9.49,17.127s-4.059,15.334-9.5,17.129a17.588,17.588,0,1,0,3.971-34.721Z",
  fill: "#c6c6c6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4444",
  "data-name": "Caminho 4444",
  d: "M336.209,140.509a17.555,17.555,0,0,0-10.9,26.517l-2.733,8.2,8.2-2.734a17.61,17.61,0,0,0,5.42,2.272c5.439-1.795,9.5-8.775,9.5-17.129S341.644,142.31,336.209,140.509Z",
  fill: "#e2e2e2"
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_285",
  "data-name": "Grupo 285"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_92",
  "data-name": "Elipse 92",
  cx: 2.513,
  cy: 2.513,
  r: 2.513,
  transform: "translate(337.659 155.122)",
  fill: "#3daa9d"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4445",
  "data-name": "Caminho 4445",
  d: "M330.119,155.122a2.514,2.514,0,1,0,2.513,2.514A2.514,2.514,0,0,0,330.119,155.122Z",
  fill: "#3daa9d"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4446",
  "data-name": "Caminho 4446",
  d: "M350.226,155.122a2.514,2.514,0,1,0,2.512,2.514A2.514,2.514,0,0,0,350.226,155.122Z",
  fill: "#3daa9d"
}))), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_93",
  "data-name": "Elipse 93",
  cx: 9.047,
  cy: 9.047,
  r: 9.047,
  transform: "translate(345.953 133.761)",
  fill: "#f87670"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4447",
  "data-name": "Caminho 4447",
  d: "M351.631,142.136l1.422,1.421,1.588-1.589v6.621h2.011V137.115Z",
  fill: "#e2e2e2"
}));

var SvgMessagesIcon = function SvgMessagesIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMessagesIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/messages-icon.0f922697.svg";
export { ForwardRef as ReactComponent };